export class WebhookV1InitiatorArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "userId",
            "baseName": "userId",
            "type": "string",
            "format": ""
        },
        {
            "name": "userName",
            "baseName": "userName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1InitiatorArguments.attributeTypeMap;
    }
    constructor() {
    }
}
